// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

interface OrderDetailsInformationStyles {
    container?: InjectableCss;
}

const orderDetailsInformation: OrderDetailsInformationStyles = {
    container: {
        css: css`
            display: flex;
            margin-bottom: 4px;
            padding-bottom: 0;
            gap: 25px;
            flex-wrap: wrap;
            align-items: flex-start;
            ${TypographyStyle}:not(span) {
                line-height: 22px;
            }
            div {
                width: 150px;
            }
        `,
    },
};

const styles = orderDetailsInformation;
const OrderDetailsInformation: FC<Props> = () => {
    return (
        <StyledWrapper {...styles.container}>
            {createWidgetElement("OrderDetails/OrderDate", {
                fields: {},
            })}
            {createWidgetElement("OrderDetails/OrderPo", {
                fields: {},
            })}
            {createWidgetElement("OrderDetails/OrderDetailsStatus", {
                fields: {},
            })}
            {createWidgetElement("OrderDetails/OrderDetailsRequestedDate", {
                fields: {},
            })}
            {createWidgetElement("OrderDetails/OrderDetailsPaymentTerms", {
                fields: {},
            })}
            {createWidgetElement("OrderDetails/OrderSalesperson", {
                fields: {},
            })}
            {createWidgetElement("OrderDetails/OrderDetailsVmiLocation", {
                fields: {},
            })}
            {createWidgetElement("OrderDetails/OrderDetailsShippingMethod", {
                fields: {},
            })}
            {createWidgetElement("OrderDetails/OrderDetailsVatNumber", {
                fields: {},
            })}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsInformation,
    definition: {
        group: "Order Details",
        displayName: "Order Details Information",
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage", "OrderDetailsRealTimePage" as any],
    },
};

export default widgetModule;
